// storage.js
const skey = 'lb_pc_'
export default {
  // 获取sessionStorage数据
  get(key) {
    let keys = skey + key
    const value = sessionStorage.getItem(keys)
    try {
      return JSON.parse(value)
    } catch (e) {
      return value
    }
  },
  // 设置sessionStorage数据
  set(key, value) {
    let keys = skey + key
    if (typeof value === 'object') {
      value = JSON.stringify(value)
    }
    sessionStorage.setItem(keys, value)
  },
  // 移除sessionStorage数据
  remove(key) {
    let keys = skey + key
    sessionStorage.removeItem(keys)
  },
  // 清空sessionStorage
  clear() {
    sessionStorage.clear()
  }
}
